export default __webpack_public_path__ + "static/media/email.9dd26a3b.png";